// import components
import { Chip, Typography } from '@mui/material';
import { StyledBoxFlexCenter } from 'components/shared/Box/Box.styles';

// import external libraries
import dayjs from 'dayjs';

// import hooks
import { useTranslation } from 'react-i18next';

// import types
import { DutyInformationDialogTopSpecsProps } from './DutyInformationDialogTopSpecs.types';

// import styles
import { StyledDutyInformationTopBox } from './DutyInformationDialogTopSpecs.styles';
import { getPeriodsStartAndEndTime } from '../HoursTable.utils';

const DutyInformationDialogTopSpecs = ({
  row
}: DutyInformationDialogTopSpecsProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'hoursTable.dutyInformation'
  });
  const { t: tRoot } = useTranslation('common');

  if (!row) return null;

  return (
    <StyledDutyInformationTopBox>
      <StyledBoxFlexCenter>
        <Typography variant="body1" width={100}>
          {t('status.title')}
        </Typography>
        {!!row?.flags?.length
          ? row.flags.map((flag) => (
              <Chip
                key={flag}
                label={t(`status.${flag}`)}
                color="primary"
                size="small"
                variant="outlined"
              />
            ))
          : '-'}
      </StyledBoxFlexCenter>
      <StyledBoxFlexCenter>
        <Typography variant="body1" width={100}>
          {t('dutyDate')}
        </Typography>
        <Typography variant="body1">
          {dayjs(row.dutyDate).format('D MMM YYYY')}
        </Typography>
      </StyledBoxFlexCenter>

      <StyledBoxFlexCenter>
        <Typography variant="body1" width={100}>
          {tRoot('dutyCode')}
        </Typography>
        <Typography variant="body1">{row.dutyCodeGeneral ?? '-'}</Typography>
      </StyledBoxFlexCenter>

      <StyledBoxFlexCenter>
        <Typography variant="body1" width={100}>
          {tRoot('period')}
        </Typography>
        <Typography variant="body1">{`${getPeriodsStartAndEndTime(row)} ${
          !!row.periods?.length ? '·' : '-'
        } ${row?.periods
          ?.map(({ dutyHourType }) => dutyHourType.description)
          .join(' ,')}`}</Typography>
      </StyledBoxFlexCenter>
    </StyledDutyInformationTopBox>
  );
};

export default DutyInformationDialogTopSpecs;
